export default "__VITE_ASSET__C$Td4D$T__"